import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

export const home: AppRouteModule = {
  path: '/home',
  name: 'Home',
  component: LAYOUT,
  redirect: '/home',
  meta: {
    hideChildrenInMenu: true,
    icon: 'icon-home',
    title: '首页',
    orderNo: 100000,
  },
  children: [
    {
      path: '/home',
      name: 'Home',
      component: () => import('/@/views/home/index.vue'),
      meta: {
        title: '首页',
        icon: 'simple-icons:about-dot-me',
      },
    },
  ],
};

export default home;
